import ListaEmpresas from './ListaEmpresas';

export default ListaEmpresas;
